<template>
<div class="content">

    <toolbar v-bind:selection="toolbar" title="Nuevo estado colmena mini" />


    <v-form ref="form" v-model="valid" lazy-validation>

        <v-text-field
                v-model="info.name"
                color="orange"
                label="Nombre colmena mini*"
                disabled
        ></v-text-field>

        <b>Estado Actual</b>

        <p>Traslarve T{{info.traslarve}}, {{info.state}} desde hace {{info.days}} días</p>


        <b>Estado Nuevo</b>
        <div class="radio-btn-group">
            <div class="radio" v-for="state in optionsState" :key="state.value" style="width:auto">
                <input type="radio" v-model="infoform.state" :id="state.value" :value="state.value">
                <label class="btn" :for="state.value">{{state.text}}</label>
            </div>
        </div>

        <p for="date" style="font-size:0.69rem;"><b>Fecha inicio estado*</b></p>
        <datepicker
                style="margin-bottom:20px;"
                name="date"
                id="date"
                v-model="infoform.date"
                format="dd/MM/yyyy"
                class="form-datepicker"></datepicker>

        <p class="v-messages__message">{{errors.date}}</p>


        <v-text-field
                v-model="infoform.traslarve"
                color="orange"
                label="Traslarve colmena mini*"
                type="number"
        ></v-text-field>



        <loading v-bind:isloading="isloading" ></loading>

        <v-alert
                dense
                v-bind:type="alertForm"
                text
                :value="alert"
                transition="scale-transition"
        >
            {{responseform}}
        </v-alert>

        <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
            Aceptar
        </v-btn>
    </v-form>

</div>
</template>

<script>
import auth from "@/libs/auth"


import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"


import axios from "axios";
import Datepicker from 'vuejs-datepicker';
import {es} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'colmena-mini-estado-nuevo',
    components: {
        toolbar,
        loading,
        Datepicker
    },
    data() {
        return {
            toolbar: {
              return: '0',
            },
        isloading:'',

        valid: true,


            /* mensaje resultado form */
            alertForm:'success',
            responseform:'',
            alert: false,

            es: es,
            errors: {
                date:''
            },

            optionsState: [

              { text: 'Realera', value: 'realera' },
              { text: 'Reina virgen', value: 'virgen' },
              { text: 'Reina Fecundada', value: 'fecundada' }
            ],

            infoform: {
                id: this.$route.params.id,
                date: (1 + new Date().getMonth()).toString() + '/' + new Date().getDate().toString() +'/' + new Date().getFullYear(),
                state: 'realera',
                traslarve: '',
            },
            info: null
        }
    },
    async created() {
    auth.getUserLogged()

        var that = this
       await axios.get("https://appws.panimiel.com/new/index.php/api/hive_mini/detail/"+this.$route.params.id).then((info) => {

            that.info = info.data

            if(that.info.state==='realera'){

                that.info.state='Realera'
                that.infoform.state='virgen'
                that.infoform.traslarve=that.info.traslarve
            }else if(that.info.state==='virgen'){
                that.info.state='Reina Virgen'
                that.infoform.state='fecundada'
                that.infoform.traslarve=that.info.traslarve
            }else if(that.info.state==='fecundada'){
                that.info.state='Reina Fecundada'
                that.infoform.state='realera'

                that.infoform.traslarve= parseInt(that.info.traslarve)+1
            }


        })

    },

    methods:{

         validate () {

            if(this.infoform.date===''){
                this.errors.date = "Debes insertar la fecha del estado."
            }else if(this.$refs.form.validate()){
                this.errors.date = ''
                this.alert = false
                this.isloading = true

                axios.post('https://appws.panimiel.com/new/index.php/api/hive_mini/state_new', this.infoform)
                     .then((response) => {
                     this.responseform = response.data


                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true
                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible insertar la colmena mini.'
                    }
                     this.alert = true
                 })
            }

        }


    }
}
</script>